//引入相应的路由组件
import home from '@/pages/home';
import Search from '@/pages/search';
import Notice from '@/pages/notice';
import Detail from '@/pages/detail';

export default [
    {
        path: '/home',
        name: '首页',
        component: home,
    }
    ,
    {
        name: 'search',
        path: '/search/:title?',
        component: Search,

    }
    ,
    {
        name: '通知公告',
        path: '/notice/:primaryColName?',
        component: Notice,
    }
    ,
    {
        name: 'detail',
        path: '/detail',
        component: Detail,
    }
    ,
    //重定向到首页
    {
        path: '/',
        redirect: '/home'
    }
]